import styled from 'styled-components'
import { Theme } from '@ocean/theme'
import { HintVariant } from './types'

type WrapperProps = {
  variant?: HintVariant
  $fill?: boolean
}

type HintVariantStyleOptions = {
  theme: Theme
  variant?: HintVariant
}

export const getHintVariantStyle = ({ theme, variant }: HintVariantStyleOptions): string => {
  switch (variant) {
    case HintVariant.Error:
      return `
        background: ${theme.color.danger};
        color: ${theme.color.white};
      `
    case HintVariant.Success:
      return `
          background: ${theme.color.greenLight};
          color: ${theme.color.black};
        `
    case HintVariant.Warning:
    default:
      return `
        background: ${theme.color.gold};
        color: ${theme.color.black};
      `
  }
}

export const Wrapper = styled.div<WrapperProps>`
  display: inline-block;

  ${({ theme, variant }) => `
    ${getHintVariantStyle({ theme, variant })}
    padding: ${theme.space.mobile.small};
    border-radius: ${theme.borderRadius.base};
  `}

  ${({ $fill }) =>
    $fill &&
    `
      display: flex;

      b, p {
        display: flex;
        flex-grow: 1;
        justify-content: space-between;
        flex-wrap: wrap;
      }
  `}
`
